import { useEffect, useState } from 'react'
import EmogSearchLayer from './EmogSearch_layer';

import { Button } from 'react-bootstrap'
import { CgDanger } from 'react-icons/cg';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { TbX } from 'react-icons/tb'

const JoinUser = ({joinUserOpen, setJoinUserOpen}) => {

    const [userJoinParams, setUserJoinParams] = useState({
        username: '',
        useridno: '',
        userpswd: '',
        reuserpswd: '',
        cmnuseIdYn: 'Y',
        cmnuseTxt: '',
        useramyn: 'N',
        useremcd: '',
        emogdesc: '',
        userauth: '',
        userprjt: 'N',
        userstrm: 'N',
        useradmn: 'N',
        admnUserMng: 'N',
        admnAuditLog: 'N',
        admnExceldownLog: 'N',
    });
    // console.log(userJoinParams)
    // 수정할 사용자 정보 set
    // const paramsList = ['useridno', 'useremcd', 'emogdesc', 'userauth', 'useradmn', 'useramyn', 'userprjt', 'userstrm', 'userpswd', 'useretc', 'admnUserMng', 'admnAuditLog', 'admnExceldownLog']
    // const setParams = paramsList.reduce((acc,key) => {
    //     if(detailData.userDetail !== undefined) {
    //         acc[key] = detailData.userDetail[key];
    //         return acc;
    //     }
    // }, {})
    
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...userJoinParams,
            [name]: type === 'checkbox' ? (checked ? 'Y' : 'N') : value
        };
        setUserJoinParams(newParams);
    };

    const getByteLength = (text) => {
        let byteLength = 0;
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i);
            if (charCode <= 0x007f) {
            byteLength += 1; // ASCII 문자
            } else if (charCode <= 0x07ff) {
            byteLength += 2; // 라틴, 일부 기호
            } else {
            byteLength += 2; // 대부분의 한글, 한자, 기타
            }
        }
        return byteLength;
    };

    // 글자수(byte) 체크
    const getByte = getByteLength(userJoinParams.userpswd);
    const userpswdByte = getByte < 257;

    // 문자 조합 정규식
    const passwordReg1 = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9,}$/;
    const passwordReg2 = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{10,}$/;
    const passwordReg3 = /^(?=.*?[a-zA-Z])(?=.*?[#?!@$%^&*-]).{10,}$/;
    const passwordReg4 = /^(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/;

    // 문자 2조합, 최소 10자리 / 문자 3조합, 최소 9자리 체크
    const userpswdValid = passwordReg1.test(userJoinParams.userpswd) || passwordReg2.test(userJoinParams.userpswd) || passwordReg3.test(userJoinParams.userpswd) || passwordReg4.test(userJoinParams.userpswd);
    // 재입력 비밀번호 일치여부
    const sameuserpswd = userJoinParams.userpswd === userJoinParams.reuserpswd;
    const isValidPswd = userpswdByte && userpswdValid

    // 공동 아이디 사유 체크
    const cmnuseIdTxt = userJoinParams.cmnuseIdYn === 'Y' && userJoinParams.cmnuseTxt > 3
    // 유효성 검사 완료 후 버튼 활성화
    const isValidCheckN = !userpswdByte || !userpswdValid || !sameuserpswd || !cmnuseIdTxt;

    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") setJoinUserOpen(false);
        };
    
        // 이벤트 리스너 등록
        document.addEventListener("keydown", handleEscape);
    
        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [joinUserOpen]);

    // 기관 선택 state
    const [selectEmog, setSelectEmog] = useState({
        emogcode: '',
        emogdesc: '',
    });
    
    // 기관 검색 modal
    const [emogSearchLayerOpen, setEmogSearchLayerOpen] = useState(false);
    const [updateEmog, setUpdateEmog] = useState(false);

    // console.log(emogSearchLayerOpen)
    return (
        <>
        {joinUserOpen &&
            <div className='modal_container'>
                <div className="mypage_contents" style={{width: '40%'}}>
                    <div className='flex'>
                        <h4 className='main_title ml-2 mb-2'>사용자 등록</h4>
                        <TbX className='ml-auto cursor-pointer' size={25} onClick={() => setJoinUserOpen(false)}/>
                    </div>
                    {/* 기관검색 modal */}
                    <EmogSearchLayer
                        containerName='mypage_modal_container'
                        wrapperName='mypage_modal_wrapper'
                        setSelectEmog={setSelectEmog}
                        setUpdateEmog={setUpdateEmog}
                        emogSearchLayerOpen={emogSearchLayerOpen} 
                        setEmogSearchLayerOpen={setEmogSearchLayerOpen}
                    />
                    <div className="mypage_wrapper">
                        <h5 className='mypage_title'>기본정보</h5>
                        <table>
                            <colgroup>
                                <col width='20%'/>
                                <col width='80%'/>
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>성명<span>&nbsp;*</span></th>
                                    <td>
                                        <input type="text" name="username" onChange={handleInputChange}/>
                                    </td>
                                </tr>
                                <tr>
                                    <th>아이디<span>&nbsp;*</span></th>
                                    <td>
                                        <input type="text" name="useridno" maxLength="10" style={{width: '85%'}} onChange={handleInputChange}/>
                                        <Button size="sm" variant="dark" className='modal_btn ml-2' onClick={() => console.log('중복확인')}>중복확인</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>비밀번호<span>&nbsp;*</span></th>
                                    <td colSpan={3}>
                                        <input type='password' name='userpswd' value={userJoinParams.userpswd} onChange={handleInputChange} placeholder='비밀번호 입력'/>
                                        <div className='visible'>
                                            <div className='validation_text' style={{color: isValidPswd ? 'green' : 'red'}}>
                                                {userpswdByte && userpswdValid ? <IoCheckmarkCircleOutline color={isValidPswd ? 'green' : 'red'} /> : <CgDanger color={isValidPswd ? 'green' : 'red'} /> }
                                                &nbsp;
                                                <span>
                                                    {!userpswdByte ? '비밀번호를 256자 이내로 입력해주세요.'
                                                    : !userpswdValid ? '아래 주의사항을 확인하여 비밀번호를 입력해주세요.'
                                                    : '사용할 수 있는 비밀번호입니다.'}
                                                </span>
                                            </div>
                                        </div>
                                        <input type='password' name='reuserpswd' value={userJoinParams.reuserpswd} onChange={handleInputChange} placeholder='비밀번호 재입력'/>
                                        <div className={`${userJoinParams.reuserpswd.length > 0 ? 'visible' : 'invisible'}`}>
                                            <div className='validation_text' style={{color: sameuserpswd ? 'green' : 'red'}}>
                                                {sameuserpswd ? <IoCheckmarkCircleOutline color={sameuserpswd ? 'green' : 'red'} /> : <CgDanger color={sameuserpswd ? 'green' : 'red'} /> }
                                                &nbsp;
                                                <span>
                                                    {sameuserpswd ? '비밀번호가 일치합니다.' : '비밀번호가 일치하지 않습니다.'}
                                                </span>
                                            </div>
                                        </div>
                                        <p className='mb-0'>※ 영문, 숫자, 특수문자 중 2종류 이상 조합 최소 10자리 또는 3종류 이상 조합 최소 9자리</p>
                                    </td>
                                    {/* <td className="my_btn">
                                        <Button size="sm" variant="primary" onClick={() => setUpdatePassOpen(true)}>비밀번호 변경</Button>
                                    </td> */}
                                </tr>
                                <tr>
                                    <th>공용ID여부</th>
                                    <td colSpan="3">
                                        {/* <label>
                                            <input 
                                                type='radio' 
                                                name='cmnuseIdYn'
                                                value='N'
                                                onChange={handleInputChange}
                                                checked={userJoinParams.cmnuseIdYn} 
                                                // disabled
                                            /> 
                                                비공용
                                        </label> */}
                                        <label>
                                            <input 
                                                type='radio' 
                                                name='cmnuseIdYn'
                                                value='Y'
                                                onChange={handleInputChange}
                                                checked={userJoinParams.cmnuseIdYn} 
                                                disabled
                                            /> 
                                                공용
                                        </label>
                                        <input type="text" name="cmnuseTxt" placeholder="사유를 입력해주세요." style={{width:"75%"}} maxLength="150" 
                                            onChange={handleInputChange} />
                                        <br/><p className='mt-2 mb-0'>※ 공용 아이디 사용 시 사유는 필수값입니다.</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="mypage_wrapper">
                        <h5 className='mypage_title'>국가응급진료정보망 추가 정보</h5>
                        <table>
                            <colgroup>
                                <col width='20%' />
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>소속기관<span>&nbsp;*</span></th>
                                    <td>
                                        <input type="text" id="emogdesc" name="pstinstName" className="width_150" style={{width: '85%'}} onChange={handleInputChange}/>
                                        <input type="hidden" id="useremcd" name="pstinstCode" />
                                        <Button size="sm" variant="dark" className='modal_btn ml-2' onClick={() => setEmogSearchLayerOpen(true)}>기관검색</Button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>접근권한<span>&nbsp;*</span></th>
                                    <td>
                                        <select id="chrgJob" name="chrgJob" style={{width: "30%", marginRight: '1rem'}} onChange={handleInputChange}>
                                            <option value="">선택</option>
                                        </select>
                                        <span>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={userJoinParams.userprjt} 
                                                    // checked={authYn.userprjt_Y} 
                                                    onChange={handleInputChange}
                                                    disabled/> 
                                                    표준등록체계(NEDIS)
                                            </label>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={userJoinParams.userstrm} 
                                                    // checked={authYn.userstrm_Y} 
                                                    onChange={handleInputChange}
                                                    disabled/> 
                                                    외상등록체계
                                            </label>
                                        </span>
                                    </td>
                                </tr>
                                {/* {!localValues.superAdmin || !filteredMngMenuY ? '' 
                                : */}
                                    {/* <tr>
                                        <th>인가권한</th>
                                        <td>
                                            <select id="chrgJob" name="chrgJob" style={{width: "30%", marginRight: '1rem'}} onChange={handleInputChange}>
                                                <option value="">선택</option>
                                            </select>
                                            <span>
                                                <label>
                                                    <input 
                                                        type="checkbox" 
                                                        // value={localValues.admnUserMng} 
                                                        // checked={authYn.admnUserMng_Y} 
                                                        onChange={handleInputChange}
                                                        disabled
                                                    /> 
                                                        사용자 관리
                                                </label>
                                                <label>
                                                    <input 
                                                        type="checkbox" 
                                                        // value={localValues.admnAuditLog} 
                                                        // checked={authYn.admnAuditLog_Y} 
                                                        onChange={handleInputChange}
                                                        disabled
                                                    /> 
                                                        감사로그
                                                </label>
                                                <label>
                                                    <input 
                                                        type="checkbox" 
                                                        // value={localValues.admnExceldownLog} 
                                                        // checked={authYn.admnExceldownLog_Y} 
                                                        onChange={handleInputChange}
                                                        disabled
                                                    /> 
                                                        엑셀 다운로드 로그
                                                </label>
                                            </span>
                                        </td>
                                    </tr> */}
                                {/* } */}
                            </tbody>
                        </table>
                    </div>
                    <div className="my_btn justify-self-center">
                        <Button size="sm" variant="primary" disabled={isValidCheckN ? 'disabled' : ''} onClick={() => console.log('등록')}>등록</Button>
                        <Button size="sm" variant="dark" onClick={() => setJoinUserOpen(false)}>닫기</Button>
                    </div>
                </div>
            </div>
        }
        </>
    )
}

export default JoinUser